{
  "locale": "Nederlands",
  "sidebar": {
    "title": "Verzoek om gegevens te delen",
    "issuanceTitle": "Verzoek om gegevens toe te voegen",
    "authenticationTitle": "Authenticatieverzoek",
    "description": "{clientName} vraagt geverifieerde persoonsgegevens op uit je identiteitsapp. Bekijk de details hieronder en keur dit verzoek goed of af in je identiteitsapp.",
    "issuanceDescription": "{clientName} voegt geverifieerde gegevens toe aan je identiteitsapp. Bekijk de details hieronder en bevestig in je identiteitsapp of je deze wilt accepteren.",
    "authenticationDescription": "{clientName} wil authenticeren met je identiteitsapp.",
    "descriptionFallback": "Een dienst vraagt geverifieerde persoonsgegevens op uit je identiteitsapp. Bekijk de details hieronder en keur dit verzoek goed of af in je identiteitsapp.",
    "issuanceDescriptionFallback": "Een dienst voegt geverifieerde gegevens toe aan je identiteitsapp. Bekijk de details hieronder en bevestig in je identiteitsapp of je deze wilt accepteren.",
    "authenticationDescriptionFallback": "Een dienst wil authenticeren met je identiteitsapp.",
    "stepsTitle": "Stappen om te voltooien",
    "stepShareData": "Gegevens delen met {clientName}",
    "stepAuthenticate": "Authenticeren voor {clientName}",
    "stepReceiveData": "Gegevens ontvangen van {clientName}",
    "stepGeneric": "Voltooi de vereiste stappen",
    "defaultClientName": "de dienst",
    "requestedDataTitle": "De volgende gegevens worden opgevraagd",
    "issuedDataTitle": "De volgende gegevens worden uitgegeven",
    "reviewNotice": "Je controleert en keurt de exacte gegevens goed in je identiteitsapp voordat er iets wordt gedeeld.",
    "issuanceReviewNotice": "Je controleert en keurt de exacte gegevens goed in je identiteitsapp voordat er iets wordt toegevoegd.",
    "indeterminateHint": "De opgevraagde gegevens worden zichtbaar nadat je een identiteitsapp hebt geselecteerd",
    "terms": "Voorwaarden",
    "termsLink": "Voorwaarden",
    "privacyLink": "Privacybeleid",
    "showAll": "Alles tonen",
    "purposeStatementTitle": "Waarom je gegevens nodig zijn",
    "retentionPolicyTitle": "Hoe je gegevens worden behandeld"
  },
  "footer": {
    "powered": "Aangedreven door",
    "terms": "Voorwaarden"
  },
  "topBar": {
    "openMenu": "Menu openen",
    "closeMenu": "Menu sluiten",
    "help": "Help",
    "language": "Taal"
  },
  "app": {
    "error": "Fout",
    "loadingTitle": "Bezig met laden",
    "loadingHint": "Een ogenblik geduld"
  },
  "language": {
    "en": "English",
    "nl": "Nederlands",
    "de": "Deutsch",
    "fr": "Français",
    "sv": "Svenska",
    "es": "Español",
    "search": "Zoeken",
    "noResults": "Geen resultaten"
  },
  "init": {
    "title": "Verzoek wordt verwerkt",
    "hint": "De sessie wordt voorbereid"
  },
  "pairing": {
    "title": "Volgende stap voorbereiden",
    "hint": "De sessie wordt voorbereid",
    "codeLabel": "Verifieer de volgende code in je identiteitsapp",
    "confirm": "Koppeling bevestigen"
  },
  "waitingForPresentation": {
    "title": "Ga verder in je identiteitsapp",
    "hint": "Controleer je identiteitsapp om het verzoek te bekijken en goed te keuren"
  },
  "agentStart": {
    "title": "Ga verder in {appName}",
    "subtitle": "Scan deze QR-code met {appName} om je gegevens veilig te delen en het verzoek goed te keuren.",
    "issuanceSubtitle": "Scan deze QR-code met {appName} om de gegevens veilig te ontvangen en het verzoek goed te keuren.",
    "step1": "Open {appName}",
    "step2": "Klik op het scannericoon",
    "step3": "Scan deze QR-code",
    "changeApp": "Identiteitsapp wijzigen",
    "installInstructions": "Installatie-instructies",
    "cancel": "Annuleren",
    "needHelp": "Hulp nodig?",
    "redirectSubtitle": "Klik op de knop hieronder om {appName} te openen en het verzoek goed te keuren.",
    "issuanceRedirectSubtitle": "Klik op de knop hieronder om {appName} te openen en het verzoek goed te keuren.",
    "redirectButton": "Doorgaan",
    "mobileSubtitle": "Om je gegevens veilig te delen, ga verder in {appName} om het verzoek te bekijken en goed te keuren.",
    "issuanceMobileSubtitle": "Om de gegevens veilig te ontvangen, ga verder in {appName} om het verzoek te bekijken en goed te keuren.",
    "openApp": "{appName} openen",
    "showQr": "QR-code tonen"
  },
  "done": {
    "disclosure": {
      "title": "Gegevens zijn succesvol gedeeld",
      "subtitle": "De pagina sluit automatisch over enkele seconden.",
      "subtitleCloseTab": "Gegevens succesvol gedeeld. Je kunt deze pagina sluiten."
    },
    "issuance": {
      "title": "Gegevens succesvol ontvangen",
      "subtitle": "De pagina sluit automatisch over enkele seconden.",
      "subtitleCloseTab": "Gegevens succesvol ontvangen. Je kunt deze pagina sluiten."
    },
    "redirecting": "Doorverwijzen...",
    "completeRedirect": "Voltooien en doorverwijzen",
    "redirectFailed": "Automatisch doorverwijzen is niet gelukt. Tik hieronder om door te gaan."
  },
  "abort": {
    "cancel": {
      "title": "Proces gestopt",
      "subtitle": "Je hebt ervoor gekozen het proces te stoppen. Je kunt op elk moment opnieuw starten."
    },
    "techFail": {
      "title": "Er is iets misgegaan",
      "subtitle": "We konden het proces niet voltooien vanwege een technisch probleem."
    },
    "timeout": {
      "title": "Sessie verlopen",
      "subtitle": "Deze sessie is be\u00ebindigd na een periode van inactiviteit. Sluit deze pagina en start het proces opnieuw om verder te gaan."
    },
    "networkLoss": {
      "title": "Verbinding verbroken",
      "subtitle": "Je internetverbinding is onderbroken. Controleer je verbinding en probeer het opnieuw."
    },
    "backendDowntime": {
      "title": "Dienst tijdelijk niet beschikbaar",
      "subtitle": "De dienst ondergaat momenteel onderhoud. Probeer het later opnieuw."
    },
    "appUnavailable": {
      "title": "Identiteitsapp niet beschikbaar",
      "subtitle": "We konden geen verbinding maken met de geselecteerde identiteitsapp. De app is mogelijk tijdelijk niet beschikbaar. Je kunt een andere identiteitsapp proberen of het later opnieuw proberen."
    },
    "selectDifferentApp": "Andere identiteitsapp selecteren",
    "confirmTitle": "Proces stoppen?",
    "confirmMessage": "Weet je zeker dat je wilt stoppen? Je kunt op elk moment opnieuw starten als je later wilt doorgaan.",
    "confirmCancel": "Annuleren",
    "confirmStop": "Proces stoppen",
    "goBack": "Terug",
    "leave": "Verlaten",
    "closePage": "Pagina sluiten",
    "restart": "Herstarten",
    "retry": "Opnieuw proberen"
  },
  "appPicker": {
    "title": "Ondersteunde identiteitsapps",
    "subtitle": "De volgende identiteitsapps kunnen worden gebruikt om het verzoek te bekijken en goed te keuren",
    "searchPlaceholder": "Zoeken...",
    "sectionLastUsed": "Laatst gebruikt",
    "sectionRecommended": "Aanbevolen",
    "sectionAZ": "A-Z",
    "noResults": "Geen apps gevonden",
    "filterTitle": "Filteren op land",
    "filterClear": "Alles wissen",
    "filterDone": "Klaar"
  },
  "faq": {
    "helpQuestion": "Vraag",
    "moreHelp": "Meer hulp",
    "close": "Sluiten",
    "whatAreWallets": {
      "title": "Wat zijn identiteitsapps?",
      "body": "Met een identiteitsapp blijf jij de baas over je eigen gegevens, alleen jij bepaalt welke gegevens je deelt, met wie en wanneer. Je gegevens worden opgehaald uit betrouwbare en geverifieerde bronnen en in de app gezet samen met een digitale handtekening die garandeert dat ze accuraat en betrouwbaar zijn.\n\nAls je gegevens deelt met een derde partij, wordt de digitale handtekening meegestuurd zodat de ontvangende partij kan vaststellen dat de gegevens authentiek zijn. Je gegevens worden doorgaans alleen op je eigen smartphone opgeslagen en zijn eenvoudig opnieuw op te halen indien nodig.\n\nWees je er altijd van bewust dat het jouw eigen verantwoordelijkheid is om zorgvuldig te kiezen met wie je jouw gegevens deelt."
    },
    "whyNotSupported": {
      "title": "Waarom wordt mijn identiteitsapp niet ondersteund?",
      "body": "Het kan voorkomen dat jouw specifieke identiteitsapp niet beschikbaar is omdat de ontvangende partij of ons platform deze momenteel niet ondersteunt. We werken er voortdurend aan om ons aanbod van ondersteunde apps uit te breiden.\n\nAls jouw app er niet bij staat kun je altijd een van de andere wel ondersteunde identiteitsapps installeren en gebruiken."
    },
    "howDataProtected": {
      "title": "Hoe worden mijn gegevens beschermd?",
      "body": "Identiteitsapps zorgen ervoor dat jij altijd de controle houdt over met wie en wanneer je jouw gegevens deelt. In deze apps staan meestal een overzicht van welke gegevens je met wie en wanneer gedeeld hebt.\n\nVer.iD stuurt je gegevens altijd direct door naar de ontvanger en controleert alleen of ze goed zijn afgeleverd. Je gegevens worden verwerkt volgens de Algemene Verordening Gegevensbescherming (AVG). De ontvanger past vervolgens zijn eigen regels toe voor bescherming van je gegevens en zal dit zelf met jou communiceren.\n\nWees je er altijd van bewust dat het jouw eigen verantwoordelijkheid is om zorgvuldig te kiezen met wie je jouw gegevens deelt."
    },
    "howObtainData": {
      "title": "Hoe kan ik gegevens in mijn app zetten?",
      "body": "Elke identiteitsapp heeft een eigen manier voor het verzamelen van gegevens. De meeste apps beschikken over een knop waarmee je gegevens kunt toevoegen. In sommige gevallen zijn hier kosten aan verbonden.\n\nVolg de instructies in de app om je gegevens op een veilige manier te verzamelen. In sommige gevallen wordt je doorverwezen naar overheidswebsites of moeten fysieke documenten zoals paspoorten of rijbewijzen worden gescand.\n\nAls je geen directe manier ziet om de juiste gegevens in de app te zetten, raadpleeg dan de documentatiepagina of neem contact op met de app leverancier. Je kunt ook een andere identiteitsapp proberen."
    },
    "whyRedirection": {
      "title": "Waarom word ik doorgestuurd?",
      "body": "Sommige identiteitsapps vereisen dat we je doorsturen naar hun eigen website zodat je gegevens worden gedeeld in overeenstemming met hun normen, in een omgeving die je gewend bent.\n\nNa succesvol delen wordt je automatisch teruggestuurd naar Ver.iD, waar je gegevens wachten op je bevestiging voordat ze worden gedeeld met de ontvangende partij. Een digitaal ontvangstbewijs is meestal te vinden in je identiteitsapp.\n\nAls het proces mislukt of wordt geannuleerd, word je ook teruggestuurd en kun je het opnieuw proberen."
    }
  },
  "dataReview": {
    "title": "Controleer de gegevens",
    "subtitleDisclosure": "Neem voordat je deelt even de tijd om de gegevens te bekijken die worden gedeeld met {clientName}.",
    "subtitleIssuance": "Neem voordat je accepteert even de tijd om de gegevens te bekijken die je ontvangt van {clientName}.",
    "issuedBy": "Gegevens uitgegeven door",
    "attribute": "Attribuut",
    "value": "Waarde",
    "cancel": "Annuleren",
    "acceptShare": "Accepteren",
    "acceptReceive": "Accepteren",
    "unknownClient": "de dienst",
    "loadingNames": "Gegevensnamen laden...",
    "errorLoadingNames": "Kon gegevensnamen niet laden. Probeer het opnieuw."
  },
  "mobileFlowStart": {
    "startVerification": "Doorgaan",
    "selectApp": "Identiteitsapp selecteren"
  },
  "requestedDataModal": {
    "title": "Opgevraagde gegevens",
    "subtitle": "Je controleert en keurt dit verzoek goed in je identiteitsapp.",
    "attribute": "Attribuut",
    "description": "Beschrijving",
    "issuedBy": "Gegevens uitgegeven door",
    "close": "Sluiten"
  },
  "demo": {
    "title": "Demo-omgeving",
    "description": "Je gebruikt een interactieve demo van Ver.iD. Deze omgeving is uitsluitend bedoeld voor demonstratiedoeleinden."
  },
  "installInstructions": {
    "title": "Installeer {appName}",
    "subtitle": "Ga naar de App Store of Play Store op je smartphone en installeer {appName} identiteitsapp. Scan de code om direct de store-pagina te openen en de app te installeren.",
    "close": "Sluiten",
    "unavailableTitle": "Instructies niet beschikbaar",
    "unavailableBody": "Sorry, we hebben op dit moment geen installatie-instructies voor deze app beschikbaar. Probeer handmatig in de app store naar de app te zoeken om verder te gaan."
  }
}
